export namespace $browser {
    const ua = navigator.userAgent;

    export const retina: boolean = window.devicePixelRatio ? (window.devicePixelRatio >= 2) : false;
    export const touch: boolean = 'ontouchstart' in document.documentElement;
    export const ios = /iPad|iPhone|iPod/.test(ua);

    retina && document.body.classList.add('y-retina');
    ios && document.body.classList.add('y-ios');
}
